import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  setErrorMessage,
  setIsNotificationVisible,
  setResultCleared,
  updateArtisticStyle,
  updateIsTryAnotherTextVisible,
} from './actions'
import { selectArtisticStyle, selectQuery } from './reducer'
import {
  logArtisticStyleSelected,
  logGenerateButtonClicked,
} from '../telemetry/telemetry'
import { selectTextToImagesLoading } from '../vb/reducer'
import './ArtisticStyle.css'
import {
  generateTextToImages,
  resetAddImage,
  resetTextToImage,
} from '../vb/actions'
import { Button } from '@zoom/react-ui'

const ArtisticStyle = ({ name, image, index, showImage, total = 12 }) => {
  const query = useSelector(selectQuery)
  const isTextToImagesLoading = useSelector(selectTextToImagesLoading)
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()
  const selectedArtisticStyle = useSelector(selectArtisticStyle)
  const isSelected = selectedArtisticStyle === name
  const nameSizeClassName =
    i18n.language === 'pl' ? 'sm' : i18n.language === 'ru' ? 'xs' : ''

  const buttonAriaLabel = `${name}, button, ${
    isSelected ? 'selected' : 'not selected'
  }, ${index + 1} of ${total}`

  const handleClick = () => {
    if (isSelected) {
      dispatch(updateArtisticStyle(null))
    } else {
      dispatch(updateArtisticStyle(name))
    }

    logArtisticStyleSelected()

    if (!showImage) {
      const styles = isSelected ? '' : ` --style=${name}`
      const prompt = query + styles
      dispatch(resetTextToImage())
      dispatch(generateTextToImages({ query: prompt }))
      dispatch(updateIsTryAnotherTextVisible(true))
      dispatch(setErrorMessage(null))
      dispatch(setIsNotificationVisible(false))
      dispatch(resetAddImage())
      dispatch(setResultCleared(false))
      logGenerateButtonClicked()
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault()
      const nextIndex =
        event.key === 'ArrowRight'
          ? (index + 1) % total
          : (index - 1 + total) % total
      document.getElementById(`artisticStyle-${nextIndex}`)?.focus()
    }
  }

  if (showImage) {
    return (
      <div className="ArtisticStyle">
        <div
          id={`artisticStyle-${index}`}
          tabIndex={0}
          onKeyDown={handleKeyDown}
          className={`ArtisticStyle__image-container ${
            isSelected ? 'selected' : ''
          } ${name === 'Japanese Ukiyo-E' ? 'lastArtisticStyle' : ''}`}
        >
          <button
            className="ArtisticStyle__image"
            onClick={handleClick}
            aria-label={buttonAriaLabel}
          >
            <img src={image} alt={image} />
          </button>
        </div>

        <p className={`ArtisticStyle__name ${nameSizeClassName}`}>{t(name)}</p>
      </div>
    )
  }

  return (
    <Button
      type="secondary"
      className={`ArtisticStyle__name ArtisticStyle__no-image ${
        isSelected ? 'selected' : ''
      } ${name === 'Japanese Ukiyo-E' ? 'lastArtisticStyle' : ''} ${
        isTextToImagesLoading ? 'disabled' : ''
      } ${nameSizeClassName}`}
      id={`artisticStyle-${index}`}
      tabIndex={0}
      onKeyDown={handleKeyDown}
      onClick={handleClick}
      aria-label={buttonAriaLabel}
      disabled={isTextToImagesLoading}
    >
      {t(name)}
    </Button>
  )
}

export default ArtisticStyle
